<template>
  <p-button
    class="btn-clear-date"
    :class="{'chrome': isChromeBrowser}"
    type="normal"
    simple
    title="Supprimer la date"
    v-if="isShown"
  >
    <span @click="clearDate">
      <img src="@/assets/svg/cross.svg" alt="Annuler">
    </span>
  </p-button>
</template>
<script>

export default {
  name: "ButtonClearDate",
  props: {
    object: {
      type: Object
    },
    name: {
      type: String
    },
    date: {
      type: String
    }
  },
  computed: {
    isShown() {
      return this.date != null && this.date != "";
    },
    isChromeBrowser() {
      return navigator.appVersion.indexOf("Chrome/") != -1;
    }
  },
  methods: {
    clearDate() {
      this.object[this.name] = null;
    }
  }
};
</script>
<style lang="scss">
.btn-clear-date {
  position: absolute;
  top: 28px;
  right: 20px;

  &.chrome {
    right: 53px;
  }
}
</style>
